// gloss
const BUILDER_METADATA_KEYS = new Set(['coerceType']);

// gloss
// why: a re-emitted-but-unchanged rule tree must compare equal to the stored one — mistaking it
// why: for an edit once wiped a folder's legacy rules.
export const canonicalConditionKey = (value: unknown): string => {
  if (Array.isArray(value)) return `[${value.map(canonicalConditionKey).join(',')}]`;
  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    for (const key of ['all', 'any'] as const) {
      const children = record[key];
      if (Array.isArray(children) && Object.keys(record).length === 1) {
        if (children.length === 1) return canonicalConditionKey(children[0]);
        if (children.length === 0) return 'null';
      }
    }
    const entries = Object.entries(record)
      .filter(([key, entry]) => !BUILDER_METADATA_KEYS.has(key) && entry !== undefined)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([key, entry]) => `${JSON.stringify(key)}:${canonicalConditionKey(entry)}`);
    return `{${entries.join(',')}}`;
  }
  return JSON.stringify(value) ?? 'null';
};

// gloss
export const isSameConditionTree = (left: unknown, right: unknown): boolean =>
  canonicalConditionKey(left) === canonicalConditionKey(right);
